module.exports = __webpack_public_path__ + "img/resized-APP-0011-1.a75458d8.png";